import { Modal } from '@vgrubs/components';
import { IntegrationAccessSection } from './IntegrationAccessSection';

type Props = {
  modalIsOpen: boolean;
  closeModal: () => void;
  locationId: number | string;
};

/**
 * Modal wrapper around IntegrationAccessSection, opened from the Location Details options
 * dropdown and from the Restaurant verification card. The section only mounts while the modal
 * is open, so its fetch happens on open, not on page load.
 */
export const IntegrationAccessModal = ({
  modalIsOpen,
  closeModal,
  locationId,
}: Props) => (
  <Modal
    isOpen={modalIsOpen}
    closeModal={closeModal}
    logo={false}
    titleWithExit="Integration Access"
    textAlign="left"
    width="640px"
  >
    <IntegrationAccessSection locationId={locationId} />
  </Modal>
);
